import React from 'react'
import { Box, makeStyles } from 'transfix-ui/core'

const useStyles = makeStyles(theme => ({
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
  termsList: {
    listStyleType: 'none',
    margin: 0,

    '& li': {
      counterIncrement: 'terms-list-counter',

      '&:before': {
        content: "counter(terms-list-counter) '. '",
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  },
}))

export const ShipmentTerms = () => {
  const classes = useStyles()

  return (
    <Box component='ol' className={classes.termsList}>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Tracking Policy
        </Box>
        <Box component='p' mb={2}>
          The driver agrees to track continuously throughout the entirety of the shipment via the
          Transfix mobile app or via Transfix approved ELD tracking. For shipments that require
          tracking, drivers who are not actively tracking via ELD or mobile app prior to pickup will
          be removed from the load. If Transfix incurs penalties or fees as a result of drivers
          failing to track, Transfix shall have the right to deduct the applicable fees and
          penalties up to 25% of carrier rate, not to exceed $200.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Load Confirmations
        </Box>
        <Box component='p' mb={2}>
          All load confirmation agreements must be returned with signature prior to pick up of any
          shipments tendered by Transfix on behalf of its customer. Failure to comply will result in
          cancellation of shipment to the carrier.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Load/Unloading
        </Box>
        <Box component='p' mb={2}>
          Carrier must observe and inspect all cargo as it is being loaded, to assure: (a) freight
          is in good order and condition without defect; (b) case/pallet count is correct as
          compared to the shipper&apos;s documents and this &lsquo;Load Confirmation&rspquo; (c) the
          freight is properly loaded and secured to prevent damage, to include temperature related
          damage and (d) upon check out carrier must verify that shipment is loaded, secured
          properly and in good condition in the event that load shifts during transit, carrier
          agrees to pay all fees and expenses associated with re-stacking as required by receiver.
          If shipper does not allow the driver to observe the loading,{' '}
          <Box component='p' className='text-error'>
            STOP AND CALL TRANSFIX IMMEDIATELY!
          </Box>{' '}
          Have Shipper to note &ldquo;SLC&rdquo; (for Shipper Load & Count) on the BOL if Carrier is
          not allowed to observe loading. All trailers must arrive at the shipper facility and be
          suitable and adequately cleaned for their intended use and capable of maintaining
          temperatures necessary for the safe transport of food on reefer loads.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Co-brokering/re-brokering
        </Box>
        <Box component='p' mb={2}>
          No shipment can be co-brokered or re-brokered without express prior written approval of
          Transfix management. If a shipment is co-brokered or re-brokered without this approval,
          the originating Carrier is responsible for all incidents and claims.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Notification of delay or other incidents affecting shipment
        </Box>
        <Box component='p' mb={2}>
          Transfix maintains an on-call operations center available 24 hours/day, 7 days/week at
          929-293-0360. All carriers are responsible to immediately notify Transfix of any and all
          loading, unloading, missed or late pickups and/or deliveries, or in-transit delays and ALL
          applicable cargo incidents, including the need to break SEALS. Carrier further agrees to
          notify Transfix immediately prior to leaving receiver upon arrival at receiver when load
          shifts or damage occurs.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Proof of Delivery & Paperwork
        </Box>
        <Box component='p' mb={2}>
          <Box component='span' className={classes.bold}>
            All pages of any paperwork - signed POD, BOLs, receipts, etc - must be submitted within
            24 hours of delivery
          </Box>{' '}
          citing in and out times, in order to process payment for accessorials and PODs. Failure to
          submit within 24 hours will result in a rejection of any additional charges including, but
          not limited to, accessorials. Electronic submission can be sent to pod@transfix.io. To
          submit NOAs/NORs please go to transfix@noa.triumphpay.com.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Accessorial Policy
        </Box>
        <Box component='p' mb={1}>
          All Accessorial charges (inclusive of Lumper Receipts, Detention, Unplanned Stops, etc)
          must be pre-approved. Unauthorized charges may not be paid; not all requests will be
          honored. The driver agrees to contact Transfix 30 minutes prior to entering detention, or
          have tracking enabled through facility arrival and departure, in order to be eligible for
          compensation. Drivers will contact Transfix by calling 929-293-0380, messaging via the
          Transfix mobile app, or emailing detention@transfix.io. Detention dry van rate is $50 /
          hour, reefer rate is $50 / hour. If the driver was not tracking or did not notify Transfix
          30 minutes prior, the rate is $40 / hour. Detention begins 2 hours after the appointment
          time. For First Come, First Served facilities, detention starts 2 hours after the arrival
          time. In order to be eligible, the driver must arrive on time for the appointment.
          Carriers must notify Transfix by emailing carriersuccess@transfix.io or by having driver
          text in 30 minutes before detention starts in order to be eligible for detention payout.
          Legible IN/OUT times are required on POD and signed off on by shipper/receiver for
          detention approval. Detention requests must be submitted within 24 hours of delivery with
          all pages of any paperwork provided. Max detention begins 5 hours after detention starts,
          or 7 hours after appointment. Dry van max detention is $250, reefer max detention is $250.
          For TEAM loads, 50% of the linehaul will be split from the agreed-upon rate and added as
          an accessorial under TEAM DRIVER. If the TEAM does not deliver on-time or Transfix is
          notified that a TEAM was not used for this shipment, the TEAM DRIVER rate will be deducted
          from the rate confirmation. The reduction will be reviewed if proof of delay is provided.
        </Box>
        <Box component='p' mb={1}>
          For TEAM loads, 50% of the linehaul will be split from the agreed-upon rate and added as
          an accessorial under TEAM DRIVER. If the TEAM does not deliver on-time or Transfix is
          notified that a TEAM was not used for this shipment, the TEAM DRIVER rate will be deducted
          from the rate confirmation. The reduction will be reviewed if proof of delay is provided.
        </Box>
        <Box component='p' className={classes.bold}>
          Weight Accessorials Rates
        </Box>
        <Box component='p'>
          1000 to 5000 lbs = $50
          <br />
          5001 to 7500 lbs = $75
          <br />
          7501 lbs or more = $100
          <br />
          For weight discrepancies, please send the BOL and light/heavy scale tickets.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Quick Pay
        </Box>
        <Box component='p' mb={2}>
          Quick Pay options are offered directly through TriumphPay. To select Quick Pay on this
          load please go through:&nbsp;
          <a href='https://secure.triumphpay.com' rel='noreferrer' target='_blank'>
            https://secure.triumphpay.com
          </a>
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Late Fee
        </Box>
        <Box component='p' mb={2}>
          If Transfix incurs penalties due to a late shipment, the Carrier agrees to a 25% late fee
          (minimum $200 late fee) should driver arrive late to delivery. Any late fees will be
          deducted from All-In rates. If an issue occurs please contact Transfix immediately and we
          may waive the late fee. To notify us, please call 929-293-0380.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Hours of Service
        </Box>
        <Box component='p' mb={2}>
          Carrier is responsible for monitoring and enforcing the driver’s hours of service. Do not
          accept the load if driver cannot make the transit legally.
        </Box>
      </Box>
      <Box component='li'>
        <Box component='span' className={classes.bold}>
          Other Terms
        </Box>
        <Box component='p' mb={2}>
          All loads are dedicated FTL. If loading partial without permission, carrier may be
          responsible for fines up to 50% of the All-In rate. Carrier must abide by any other
          shipping requirements provided to carrier upon tender. TONU payments to the carrier are
          subject to change pending customer approval. If the carrier can provide sufficient proof
          of on-time pickup (i.e. tracking via the Transfix App) and the customer denies payment,
          Transfix will issue a TONU payment to the carrier. This Rate Confirmation is included by
          reference the Broker Carrier Agreement (the BCA), and all terms and conditions found in
          the BCA between TRANSFIX and Carrier shall apply. In the event of conflict between these
          terms and the terms and conditions of the BCA, the BCA will apply. Carrier acknowledges
          and agrees that the Parties do not intend to create or form a constructive trust, and
          Carrier waives and agrees not to claim or assert any such trust. Carrier further agrees
          that it shall look to and accept payment of its rates and charges only from TRANSFIX, and
          not from any customer of TRANSFIX.
        </Box>
      </Box>
    </Box>
  )
}
